// extracted by mini-css-extract-plugin
module.exports = {"root":"c6e8ba5398--root--1PVub"};